import React, { useEffect, useState, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Box, Container, Menu, MenuItem, TextField } from "@material-ui/core";
import Title from "../../ui/Title";
import { useBmapi } from "../../utils/bmapi-context";
import { useCampaigns } from "../../utils/campaigns";
import MessageCampaingCreateForm from "../../ui/forms/MessageCampaingCreateForm";
import { MANAGER_ROUTES } from "../../utils/constants";
import FormSection from "../../ui/forms/input/FormSection";
import { getErrorMessageString } from "../../utils/errors";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import { campaign, common } from "../../messages";
//import { format } from "date-fns";

function byBusinessName(a, b) {
  return a.business_name.localeCompare(b.business_name);
}

function initValues() {
  return { campaign: null, title: "", body: "" };
}

export default function Campaigns() {
  const {
    bmapi,
    businessId,
    startLoading,
    stopLoading,
    notifySuccess,
    notifyError,
  } = useBmapi();
  const history = useHistory();
  const { campaigns, loadCampaigns } = useCampaigns();
  const [currentStore, setCurrentStore] = useState(0);
  const [values, setValues] = useState(initValues());
  const [anchorEl, setAnchorEl] = useState(null);
  const [stores, setStores] = useState(null);
  const intl = useIntl();

  const defaultLanguage = bmapi.settings.language?.default || "en";
  const availableLanguages = bmapi.settings.language?.other || [];

  const selectStore = (id) => {
    setCurrentStore(id);
    setAnchorEl(null);
  };

  useEffect(() => {
    !campaigns ? startLoading() : stopLoading();
  }, [campaigns, startLoading, stopLoading]);

  useEffect(() => {
    if (campaigns) {
      campaigns.push({
        name: intl.formatMessage(campaign.noCampaign),
        campaign_id: "-",
        business_name: "",
        isActive: true,
      });
      setStores(
        Object.entries(
          campaigns.sort(byBusinessName).reduce(
            (acc, e) => ({
              ...acc,
              [e.business_owner_id]: e.business_owner_name,
            }),
            {}
          )
        )
      );
      setValues({ campaign: "-" /*campaigns[0].campaign_id*/ });
    }
    // eslint-disable-next-line
  }, [campaigns]);

  useEffect(() => {
    loadCampaigns();
  }, [loadCampaigns]);

  const handleSubmit = (fields, after) => {
    if (!fields.banner_close) {
      fields.banner_close_mode = "";
      fields.banner_close_date = "";
      fields.banner_close_number = "";
    } else {
      if (fields.close_time) {
        fields.banner_close_date = `${format(
          fields.close_date,
          "yyyy-MM-dd"
        )}T${format(fields.close_time, "HH:mm:00")}`;
      } else {
        fields.banner_close_date = `${format(
          fields.close_date,
          "yyyy-MM-dd"
        )}T00:00:00`;
      }
    }

    delete fields.close_date;
    delete fields.close_time;

    startLoading();
    //const client_id = "16d4c11d-1798-4217-8834-d0fe37a4c49c";
    const client_id = "";
    return bmapi
      .saveMessageCampaign(
        fields.title,
        fields.body,
        fields.banner,
        fields.banner_close_mode,
        //fields.banner ? fields.banner_close_mode : "",
        fields.banner_close_mode === "DAY" ? fields.banner_close_date : "",
        fields.banner_close_mode === "DAY" ? 0 : +fields.banner_close_number,
        fields.push_notification,
        fields.expire_at ? format(fields.expire_at, "yyyy-MM-dd") : "",
        fields.app_link_label,
        fields.app_link_uri,
        fields.image_url,
        fields.link_uri,
        values.campaign == "-" ? "" : values.campaign,
        client_id,
        fields.body_format,
        fields.auto_distr,
        fields.localized
      )
      .then(after)
      .then(() => {
        notifySuccess(
          intl.formatMessage({
            id: "pages.messageCampaign.create",
            defaultMessage: "Messaggio creato con successo",
          })
        );
        history.push(
          MANAGER_ROUTES.MESSAGES_CAMPAIGNS.replace(":campaignId?/", "")
        );
      })
      .catch((e) => {
        notifyError(getErrorMessageString(e, intl));
        //stopLoading();
      })
      .finally(stopLoading);
  };

  const handleChange = useCallback((label) => {
    const updateValue = (val) => {
      setValues((v) => ({ ...v, [label]: val }));
    };

    return (i, f) => {
      if (typeof f === "boolean") updateValue(f);
      else if (i?.target) updateValue(i.target.value);
      else updateValue(i);
    };
  }, []);

  function CampaignsList({ campaigns }) {
    const options = [
      ...campaigns.filter((s) => s.isActive),
      {
        name: intl.formatMessage(campaign.noCampaign),
        campaign_id: "-",
      },
    ];

    return (
      <Box>
        <TextField
          name="front_end_type"
          label={intl.formatMessage(common.campaign)}
          value={values.campaign ?? "-"}
          onChange={handleChange("campaign")}
          select
          fullWidth
          required
          margin="normal"
        >
          {options.map((option) => (
            <MenuItem key={option.campaign_id} value={option.campaign_id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    );
  }

  return !businessId ? (
    <Container maxWidth="md" className="tablistNone"></Container>
  ) : campaigns ? (
    <Container maxWidth="sm">
      <Title>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Box>
            <FormattedMessage
              id="pages.campaigns.create"
              defaultMessage="Creazione Messaggio"
            />
          </Box>

          <Menu
            anchorEl={anchorEl}
            keepMounted={false}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem onClick={() => selectStore(0)}>
              <FormattedMessage
                id="common.allStores"
                defaultMessage="Tutti i negozi"
              />
            </MenuItem>
            {stores?.map((option) => (
              <MenuItem
                key={option[0]}
                onClick={() => selectStore(option[0])}
                selected={option[0] === currentStore}
              >
                {option[1]}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Title>
      <FormSection>
        <CampaignsList campaigns={campaigns} />
      </FormSection>
      <MessageCampaingCreateForm
        handleSubmit={handleSubmit}
        style={{ background: "red" }}
        availableLanguages={availableLanguages}
        defaultLanguage={defaultLanguage}
      />
    </Container>
  ) : null;
}
